import { useMemo, useEffect, useState, useContext } from "react";
import _ from "lodash";
import { dataModificationTypes } from "global/viewSettings/enums/itemActionTypes";
import { getFirstObject } from "global/common/convert";
import { ParentContext } from "../ParentContext";
import { FrameworkContext } from "../FrameworkContent";
import { addPropItem } from "global/optionLists/additionalProps";
import { propDataOpts } from "global/viewSettings/settingsProps/settingsAll";
import { gEnums, listTypes } from "global/enums/globalEnums";

export const useModifyProps = ({
  viewItem,
  itemData,
  dataModificationType,
  editableItem
}) => {

  const { key: vit } = viewItem ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states
  const { aps_global, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  const { dataPermissions } = aps_global ?? {}
  const { restrictArrayEdits } = dataPermissions ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { frameworkRightType, frInfos, currentSwiperTab } = framework_state ?? {}
  const frInfo = frameworkRightType && frInfos && frInfos?.[currentSwiperTab]
  const { uivi, viewItem: viewItem_fr } = frInfo ?? {}

  const _viewItem = viewItem_fr ? viewItem_fr : viewItem
  const _vit = uivi ? uivi : vit

  const viewItem_g = aps_viewItems[_vit]

  const props_viewItem = _vit?.props
  const props_viewItem_g = viewItem_g?.props

  const props_true = props_viewItem_g || props_viewItem;
  const _useGlobalProps = !!props_viewItem_g;

  const { dataModifications } = _vit ?? {}
  const { edit } = dataModifications ?? {}
  const { subEditProps } = edit ? edit : {}

  const [propsModify, setPropsModify] = useState({});

  // 🔹 Compute modify props
  const computedModifyProps = useMemo(() => {

    let modify = {};
    let modifyX = {};

    if (!props_true) return {};

    console.log('dataModificationType', dataModificationType)
    console.log('props_true', props_true)

    switch (dataModificationType) {
      case dataModificationTypes.add: {
        _.forEach(props_true, (pi, key) => {
          const pi_g = props_viewItem_g?.[key] ?? {};
          const { restrictAdd: restrictAdd_p, data, remove } = pi ?? {};
          const { restrictAdd: ignoreOnAddEdit } = data ?? {};
          const restrictAdd = restrictAdd_p || ignoreOnAddEdit || remove;

          if (!restrictAdd) {
            modify[key] = _useGlobalProps ? pi_g : pi;
          } else {
            modifyX[key] = _useGlobalProps ? pi_g : pi;
          }
        });
        break;
      }

      case dataModificationTypes.edit: {
        const { item: item_data } = itemData ? getFirstObject(itemData) : {};
        const { key: key_viewItem } = _vit ?? {};

        if (editableItem) {
          _.forEach(editableItem, (val, k) => {
            modify[k] = { ...val, propSection: "name" };
          });
        } else if (subEditProps && !_.isEmpty(subEditProps)) {
          _.forEach(props_true, (pi, propKey) => {
            if (subEditProps.includes(propKey)) {
              modify[propKey] = pi;
            }
            addDefaultProp(props_true, modify, "name");
            addDefaultProp(props_true, modify, "firstName");
            addDefaultProp(props_true, modify, "lastName");
          });
        } else {
          _.forEach(props_true, (pi, key) => {
            const propValue = item_data?.[key];
            const restrictArray = false;
            // restrictArrayEdits &&
            // _.isArray(propValue) &&
            // _.size(propValue) > 1;

            // console.log('restrictArray', key, restrictArray)
            const pi_g = props_viewItem_g?.[key] ?? {};
            const { restrictAdd: restrictAdd_p, data, remove } = pi ?? {};
            const { restrictAdd: ignoreOnAddEdit } = data ?? {};
            const restrictEdit = restrictAdd_p || ignoreOnAddEdit || remove || restrictArray;
            if (!restrictEdit) {
              modify[key] = _useGlobalProps ? pi_g : pi;
            } else {
              // modifyX[key] = _useGlobalProps ? pi_g : pi;
            }
          });
        }
        break;
      }

      default:
        modify = props_true;
        break;
    }

    addPropItem(viewItem, modify, 'itemStatusType', propDataOpts(false, gEnums.formItemTypes.select, listTypes.statusTypes))
    modify['itemStatusType'] = x('itemStatusType')

    // console.group('useModifyProps', dataModificationType, restrictArrayEdits)
    // console.log('modify', modify)
    // console.log('editableItem', editableItem)
    // console.groupEnd()

    return { modify: _.pickBy(modify, _.isPlainObject), modifyX };
  }, [
    dataModificationType,
    // props_true,
    // itemData,
    // editableItem,
    // props_viewItem_g,
    // subEditProps,
    // restrictArrayEdits,
  ], []);

  // 🔹 Sync to state (optional; allows for async effects)
  useEffect(() => {
    setPropsModify(computedModifyProps.modify);
  }, [computedModifyProps]);

  return propsModify;
};

const addDefaultProp = (props_viewItem, mps, propKey) => {
  if (props_viewItem[propKey] && !mps[propKey]) {
    mps[propKey] = props_viewItem[propKey]
    mps[propKey].data.readOnly = true
  }
}

const x = (key) => {
  return {
    data: {
      formItemType: gEnums.formItemTypes.select,
      listType: 'statusTypes'
    },
    propSection: key,
    key: key,
    display: {
      caption: _.startCase(key),
      elemPropType: gEnums.elemPropTypes.normal
    },
    ui: {
      caption: _.startCase(key),
    },
    show: true,
    position: 10,
  }
}